export const FOOTER_TEXTS = {
  headings: {
    useful: 'Полезные ссылки',
    partners: 'Партнеры',
    social: 'Мы в социальных сетях',
    app: 'Все туры в одном приложении',
    skolkovo: 'Участник проекта «Сколково»',
  },
  phone: '8 (495) 786-55-00',
  schedule: 'КРУГЛОСУТОЧНО',
  description:
    'Travelata.ru – это туристическая компания нового поколения. Мы используем все ' +
    'доступные сегодня технологии чтобы сделать выбор, оплату и бронирование Вашего ' +
    'путешествия максимально удобными и приятными.',
  copyright: '2011-2015 © Travelata.ru',
} as const;
